/* tslint:disable */
/* eslint-disable */
/**
 * Bonds API
 * Microservice backend for bond management
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import dayjs from 'dayjs';
import type {
  CreateInvestorOrder,
  EndOwnershipInput,
  ListInvestorOrder,
} from '../models/index';
import {
    CreateInvestorOrderFromJSON,
    CreateInvestorOrderToJSON,
    EndOwnershipInputFromJSON,
    EndOwnershipInputToJSON,
    ListInvestorOrderFromJSON,
    ListInvestorOrderToJSON,
} from '../models/index';

export interface CreateInvestorOrderRequest {
    xCFGINVESTORUSERID: string;
    createInvestorOrder: CreateInvestorOrder;
}

export interface DeleteInvestorOrderRequest {
    xCFGINVESTORUSERID: string;
    id: number;
}

export interface EndOwnershipsRequest {
    xCFGINVESTORUSERID: string;
    id: number;
    endOwnershipInput: EndOwnershipInput;
}

export interface ListInvestorProfileOrdersRequest {
    xCFGINVESTORUSERID: string;
    iSSUEISIN?: string;
}

/**
 * 
 */
export class InvestorOrdersApi extends runtime.BaseAPI {

    /**
     */
    async createInvestorOrderRaw(requestParameters: CreateInvestorOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateInvestorOrder>> {
        if (requestParameters['xCFGINVESTORUSERID'] == null) {
            throw new runtime.RequiredError(
                'xCFGINVESTORUSERID',
                'Required parameter "xCFGINVESTORUSERID" was null or undefined when calling createInvestorOrder().'
            );
        }

        if (requestParameters['createInvestorOrder'] == null) {
            throw new runtime.RequiredError(
                'createInvestorOrder',
                'Required parameter "createInvestorOrder" was null or undefined when calling createInvestorOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCFGINVESTORUSERID'] != null) {
            headerParameters['X-CFG-INVESTOR-USER-ID'] = String(requestParameters['xCFGINVESTORUSERID']);
        }

        const response = await this.request({
            path: `/api/investors/v1/orders/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateInvestorOrderToJSON(requestParameters['createInvestorOrder']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateInvestorOrderFromJSON(jsonValue));
    }

    /**
     */
    async createInvestorOrder(requestParameters: CreateInvestorOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateInvestorOrder> {
        const response = await this.createInvestorOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteInvestorOrderRaw(requestParameters: DeleteInvestorOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['xCFGINVESTORUSERID'] == null) {
            throw new runtime.RequiredError(
                'xCFGINVESTORUSERID',
                'Required parameter "xCFGINVESTORUSERID" was null or undefined when calling deleteInvestorOrder().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteInvestorOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCFGINVESTORUSERID'] != null) {
            headerParameters['X-CFG-INVESTOR-USER-ID'] = String(requestParameters['xCFGINVESTORUSERID']);
        }

        const response = await this.request({
            path: `/api/investors/v1/orders/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteInvestorOrder(requestParameters: DeleteInvestorOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteInvestorOrderRaw(requestParameters, initOverrides);
    }

    /**
     */
    async endOwnershipsRaw(requestParameters: EndOwnershipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['xCFGINVESTORUSERID'] == null) {
            throw new runtime.RequiredError(
                'xCFGINVESTORUSERID',
                'Required parameter "xCFGINVESTORUSERID" was null or undefined when calling endOwnerships().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling endOwnerships().'
            );
        }

        if (requestParameters['endOwnershipInput'] == null) {
            throw new runtime.RequiredError(
                'endOwnershipInput',
                'Required parameter "endOwnershipInput" was null or undefined when calling endOwnerships().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCFGINVESTORUSERID'] != null) {
            headerParameters['X-CFG-INVESTOR-USER-ID'] = String(requestParameters['xCFGINVESTORUSERID']);
        }

        const response = await this.request({
            path: `/api/investors/v1/orders/{id}/endOwnerships/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EndOwnershipInputToJSON(requestParameters['endOwnershipInput']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async endOwnerships(requestParameters: EndOwnershipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.endOwnershipsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async listInvestorProfileOrdersRaw(requestParameters: ListInvestorProfileOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ListInvestorOrder>>> {
        if (requestParameters['xCFGINVESTORUSERID'] == null) {
            throw new runtime.RequiredError(
                'xCFGINVESTORUSERID',
                'Required parameter "xCFGINVESTORUSERID" was null or undefined when calling listInvestorProfileOrders().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['iSSUEISIN'] != null) {
            queryParameters['ISSUE_ISIN'] = requestParameters['iSSUEISIN'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCFGINVESTORUSERID'] != null) {
            headerParameters['X-CFG-INVESTOR-USER-ID'] = String(requestParameters['xCFGINVESTORUSERID']);
        }

        const response = await this.request({
            path: `/api/investors/v1/orders/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ListInvestorOrderFromJSON));
    }

    /**
     */
    async listInvestorProfileOrders(requestParameters: ListInvestorProfileOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ListInvestorOrder>> {
        const response = await this.listInvestorProfileOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
